import { useTheme } from 'styled-components'

import { IconBase, IconProps } from './Base'

export const IconArrowRight = (props: IconProps) => {
  const theme = useTheme()

  return (
    <IconBase width={props.width || 24} height={props.height || 24} viewBox="0 0 24 24" fill="none">
      <g
        stroke={theme.colors.text.primary}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        clipPath="url(#a)"
      >
        <path d="m18 8 4 4-4 4M22 12H2" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </IconBase>
  )
}

export const IconArrowRightSmall = (props: IconProps) => {
  const theme = useTheme()

  return (
    <IconBase width={props.width || 13} height={props.height || 13} viewBox="0 0 13 12" fill="none">
      <g clipPath="url(#clip0_4894_16636)">
        <path
          d="M9.5 4L11.5 6L9.5 8"
          stroke={theme.colors.text.primary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.5 6H1.5"
          stroke={theme.colors.text.primary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4894_16636">
          <rect width="12" height="12" fill="white" transform="matrix(-1 0 0 1 12.5 0)" />
        </clipPath>
      </defs>
    </IconBase>
  )
}
